import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Table } from "../..";
import AdvancedTableCell from "./AdvancedTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AdvancedTableRow = function AdvancedTableRow(props) {
  var item = props.item,
    selectedCell = props.selectedCell,
    selectedRow = props.selectedRow,
    columns = props.columns,
    value = props.value,
    actionsRow = props.actionsRow,
    onChange = props.onChange,
    onBlur = props.onBlur,
    onCellClick = props.onCellClick,
    onRowSelect = props.onRowSelect;
  var identifiant = item.identifiant;
  return /*#__PURE__*/_jsxs(Table.Row, Object.assign({
    active: selectedRow === identifiant
  }, !_.isNil(onRowSelect) && {
    onClick: function onClick() {
      return onRowSelect(item);
    },
    style: {
      cursor: 'pointer'
    }
  }, {
    children: [_.map(columns, function (column) {
      return /*#__PURE__*/_jsx(AdvancedTableCell, {
        column: column,
        selected: (selectedCell == null ? void 0 : selectedCell.identifiant) === identifiant && (selectedCell == null ? void 0 : selectedCell.property) === column.property,
        onChange: onChange,
        value: value,
        item: item,
        onClick: onCellClick,
        onBlur: onBlur
      }, "cell-" + column.property);
    }), _.isFunction(actionsRow) && /*#__PURE__*/_jsx(Table.Cell, {
      singleLine: true,
      className: "actions",
      children: actionsRow(item)
    })]
  }), "elementRow-" + identifiant);
};
AdvancedTableRow.handledProps = ["actionsRow", "columns", "item", "onBlur", "onCellClick", "onChange", "onRowSelect", "selectedCell", "selectedRow", "value"];
AdvancedTableRow.propTypes = {
  /**
     * élement de la ligne
     */
  item: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * Informations de la cellule sélectionnée
     */
  selectedCell: PropTypes.shape({
    identifiant: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    property: PropTypes.string
  }),
  /**
     * Identifiant de la ligne sélectionnée
     */
  selectedRow: PropTypes.number,
  /**
     * Définitions des colonnes
     */
  // eslint-disable-next-line react/forbid-prop-types
  columns: PropTypes.arrayOf(PropTypes.object),
  /**
     * Valeur de la cellule en modification
     */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
     * Actions d'une ligne
     */
  actionsRow: PropTypes.func,
  /**
     * Callback de changement
     */
  onChange: PropTypes.func,
  /**
     * Callback au blur de l'input
     */
  onBlur: PropTypes.func,
  /**
     * Callback à la sélection d'une cellule
     */
  onRowSelect: PropTypes.func,
  /**
     * Callback au clic d'une cellule
     */
  onCellClick: PropTypes.func
};
AdvancedTableRow.defaultProps = {
  item: {},
  selectedRow: 0,
  columns: [],
  selectedCell: {},
  value: undefined,
  actionsRow: null,
  onChange: null,
  onBlur: null,
  onRowSelect: null,
  onCellClick: null
};
export default AdvancedTableRow;